import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { logoUrl } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Amenities', href: '#amenities' },
    { name: 'Gallery', href: '#gallery' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'Contact', href: '#contact' },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#FAF9F7]/95 backdrop-blur-md shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" className="flex items-center">
          <img
            src={logoUrl}
            alt="Elite Marriage Lawns"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className={`font-sans text-sm tracking-wider uppercase transition-colors duration-300 ${
                isScrolled
                  ? 'text-[#2C2C2C] hover:text-[#C9A962]'
                  : 'text-white hover:text-[#C9A962]'
              }`}
            >
              {link.name}
            </a>
          ))}
        </nav>

        {/* CTA Button - Desktop */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:7607837676"
            className={`flex items-center gap-2 text-sm font-medium transition-colors ${
              isScrolled ? 'text-[#C9A962]' : 'text-[#C9A962]'
            }`}
          >
            <Phone size={16} />
            <span>7607837676</span>
          </a>
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, '#contact')}
            className="btn-primary text-xs px-6 py-3"
          >
            Book Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className={`lg:hidden p-2 transition-colors ${
            isScrolled ? 'text-[#2C2C2C]' : 'text-white'
          }`}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-[#FAF9F7] shadow-xl transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col py-6 px-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="py-3 text-[#2C2C2C] font-sans tracking-wider uppercase text-sm border-b border-[#D4C4B0]/30 hover:text-[#C9A962] transition-colors"
            >
              {link.name}
            </a>
          ))}
          <a
            href="tel:7607837676"
            className="flex items-center gap-2 py-3 text-[#C9A962] font-medium"
          >
            <Phone size={16} />
            <span>7607837676</span>
          </a>
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, '#contact')}
            className="btn-primary text-center mt-4 text-xs"
          >
            Book Now
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
